const newContainer = () => import("@/layouts/Default.vue");
// import exportMainSearch from "./../views/../views/report/exportMainSearch.vue";
// import finalReportVotes from "./../views/finalReport/finalReportVotes.vue";
// import finalReportVotes2 from "./../views/finalReport/finalReportVotes2.vue";
// import readyReportAccessSearch from "./../views/report/readyReportAccessSearch.vue";
// import readyReportSearch from "../views/report/readyReportSearch.vue";
// import reportDashboard from "./../views/dashboard/index.vue";

const reportPaymentsSearch = () =>
  import("../views/payment/components/reportPaymentsSearch.vue");

const noNeedQualificationList = () =>
  import("../views/finalReport/noNeedQualificationList.vue");
const readyQualification = () =>
  import("../views/finalReport/readyQualificationSearch.vue");
const readyCommitmentList = () =>
  import("../views/ready-commitment/readyCommitmentList.vue");
const commitmentList = () => import("../views/commitment/commitmentList.vue");
const myResponsibilityCommitmentsList = () =>
  import(
    "../views/my-responsibility-commitments/myResponsibilityCommitmentsList.vue"
  );
const myResponsibilityCommitmentsForm = () =>
  import(
    "../views/my-responsibility-commitments/myResponsibilityCommitmentsForm.vue"
  );

const myPaymentsList = () => import("../views/payment/myPaymentsList.vue");
const routerParent = () => import("@/layouts/routerParrent.vue");
const searchPaymentNoNeed = () =>
  import("../views/payment/searchPaymentNoNeed.vue");
const allJobsLogList = () => import("../views/jobs-log/allJobsLogList.vue");
const myJobsLogList = () => import("../views/jobs-log/myJobsLogList.vue");
const dashboard = () => import("../views/dashboard/index.vue");
const exportExcelList = () =>
  import("../views/export-excel/exportExcelList.vue");
const readyReportList = () =>
  import("../views/ready-report/readyReportList.vue");
const competencyMatrixList = () =>
  import("../views/competency-matrix/competencyMatrixList.vue");
const competencyMatrixDetail = () =>
  import("../views/competency-matrix/competencyMatrixDetail.vue");

const ReadyReportAccessList = () =>
  import("../views/readyReportAccess/ReadyReportAccessList.vue");

const termDashboard = () => import("../views/term-dashboard/index.vue");
const termDashboardDetail = () => import("../views/term-dashboard/detail.vue");

const MyReports = () => import("../views/my-reports/MyReports.vue");
const reportAccessList = () =>
  import("../views/reportAccess/reportAccessList.vue");

export const reportRoutes: any[] = [
  {
    path: "/report",
    name: "report",
    meta: {
      label: "خانه",
      moduleName: "report",
    },
    component: newContainer,
    children: [
      {
        path: "payments",
        name: "payments",
        meta: {
          label: "پرداخت",
          requiresAuth: true,
          redesigned: true,
        },
        component: routerParent,
        redirect: "/report/payments/search",
        children: [
          {
            path: "search",
            name: "report_payment_search",
            component: reportPaymentsSearch,
            meta: {
              label: "لیست سوابق پرداختی",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: "payment-no-need",
            name: "payment_no_need",
            component: searchPaymentNoNeed,
            meta: {
              label: "لیست عدم پرداخت یا تخفیف",
              redesigned: true,
              requiresAuth: true,
            },
          },
        ],
      },
      {
        path: "my-payments",
        name: "my-payments",
        meta: {
          label: "پرداخت‌های من",
          requiresAuth: true,
          redesigned: true,
        },
        component: routerParent,
        redirect: "/report/my-payments/list",
        children: [
          {
            path: "list",
            name: "my_report_payment_search",
            component: myPaymentsList,
            meta: {
              label: "پرداخت‌های من",
              requiresAuth: true,
              redesigned: true,
            },
          },
        ],
      },
      {
        path: "ready-commitment",
        name: "ready_commitment",
        meta: {
          label: "تعیین صلاحیت",
          requiresAuth: true,
        },
        redirect: "/report/ready-commitment/list",
        component: routerParent,
        children: [
          {
            path: "list",
            name: "ready-commitment-list",
            component: readyCommitmentList,
            meta: {
              label: "آماده اخذ تعهد",
              requiresAuth: true,
              redesigned: true,
            },
          },
        ],
      },
      {
        path: "commitment",
        name: "commitment",
        meta: {
          label: "تعیین صلاحیت",
          requiresAuth: true,
        },
        redirect: "/report/commitment/list",
        component: routerParent,
        children: [
          {
            path: "list",
            name: "commitment-list",
            component: commitmentList,
            meta: {
              label: "تعهد‌ها",
              requiresAuth: true,
              redesigned: true,
            },
          },
        ],
      },
      {
        path: "my-responsibility-commitments",
        name: "my_responsibility_commitments",
        meta: {
          label: "تعیین صلاحیت",
          requiresAuth: true,
        },
        redirect: "/report/my-responsibility-commitments/list",
        component: routerParent,
        children: [
          {
            path: "list",
            name: "my-responsibility-commitments-list",
            component: myResponsibilityCommitmentsList,
            meta: {
              label: "تعهدها با مسئولیت من",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: ":code/form",
            name: "my-responsibility-commitments-form",
            component: myResponsibilityCommitmentsForm,
            meta: {
              label: "مشاهده فرم تعهد‌نامه",
              requiresAuth: true,
              redesigned: true,
            },
          },
        ],
      },
      {
        path: "ready-qualification",
        name: "qualification",
        meta: {
          label: "تعیین صلاحیت",
          requiresAuth: true,
        },
        redirect: "/report/ready-qualification/list",
        component: routerParent,
        children: [
          {
            path: "list",
            name: "ready-qualification-list",
            component: readyQualification,
            meta: {
              label: "آماده تعیین صلاحیت",
              requiresAuth: true,
              redesigned: true,
            },
          },
        ],
      },
      {
        path: "final_report",
        name: "final_report",
        meta: {
          label: "تعیین صلاحیت",
          requiresAuth: true,
        },
        redirect: "/report/final_report/search",
        component: routerParent,
        children: [
          {
            path: "search",
            name: "finalReportSearch",
            // component: finalReportSearch,
            meta: {
              label: "لیست تعیین صلاحیت",
              requiresAuth: true,
              redesigned: false,
            },
          },
          {
            path: "no-need-qualification",
            name: "noNeedQualification",
            component: noNeedQualificationList,
            meta: {
              label: "عدم نیاز به تعیین صلاحیت",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: "votes/:code",
            name: "finalReportVotes",
            // component: finalReportVotes,
            meta: {
              label: "مشاهده گزارش تعیین صلاحیت",
              requiresAuth: true,
            },
          },
          {
            path: "votes2/:code",
            name: "finalReportVotes2",
            // component: finalReportVotes2,
            meta: {
              label: "فرم اظهار نظر هیئت تعیین صلاحیت",
              requiresAuth: true,
            },
          },
          {
            path: "votes3/:code",
            name: "finalReportVotes3",
            // component: finalReportVotes2,
            meta: {
              label: "فرم اظهار نظر هیئت تعیین صلاحیت",
              requiresAuth: true,
            },
          },
          {
            path: "votes_group/:code",
            name: "finalReportVotesGroup",
            // component: finalReportVotes2,
            meta: {
              label: "فرم رای دهی گروهی",
              requiresAuth: true,
            },
          },
        ],
      },
      {
        path: "export-excel",
        name: "export_excel",
        meta: {
          label: "خروجی اکسل",
          requiresAuth: true,
        },
        component: routerParent,
        redirect: "/report/export-excel/list",
        children: [
          {
            path: "list",
            name: "export_excel_show",
            component: exportExcelList,
            meta: {
              label: " لیست خروجی‌های اکسل",
              requiresAuth: true,
              redesigned: true,
            },
          },
        ],
      },
      {
        path: "ready-report",
        name: "ready_report",
        meta: {
          label: "گزارش‌",
          requiresAuth: true,
        },
        component: routerParent,
        redirect: "/report/ready-report/list",
        children: [
          {
            path: "list",
            name: "ready_report_list",
            component: readyReportList,
            meta: {
              label: "گزارش‌های آماده",
              requiresAuth: true,
              redesigned: true,
            },
          },
        ],
      },
      {
        path: "ready-report/access",
        name: "ready_report_access",
        component: ReadyReportAccessList,
        meta: {
          label: "دسترسی گزارش‌های آماده",
          requiresAuth: true,
          redesigned: true,
        },
      },
      {
        path: "jobs-log",
        name: "jobs-log",
        redirect: "/report/jobs-log/list",
        meta: {
          label: "تاریخچه همه فرایندها",
          requiresAuth: true,
          redesigned: true,
        },
        children: [
          {
            path: "list",
            name: "jobs_log",
            component: allJobsLogList,
            meta: {
              label: "تاریخچه همه فرایندها",
              requiresAuth: true,
              redesigned: true,
            },
          },
        ],
      },
      {
        path: "my-jobs-log",
        name: "my-jobs-log",
        redirect: "/report/my-jobs-log/list",
        meta: {
          label: "تاریخچه همه فرایندها",
          requiresAuth: true,
          redesigned: true,
        },
        children: [
          {
            path: "list",
            name: "my_jobs_log",
            component: myJobsLogList,
            meta: {
              label: "تاریخچه فرایندهای من",
              requiresAuth: true,
              redesigned: true,
            },
          },
        ],
      },
      {
        path: "dashboard",
        name: "report_dashboard",
        component: dashboard,
        meta: {
          label: "داشبورد گزارش",
          requiresAuth: true,
          hasMaxWidth: false,
          redesigned: true,
        },
      },
      {
        path: "competency-matrix",
        name: "competency_matrix",
        redirect: "/report/competency-matrix/list",
        meta: {
          label: "ماتریس شایستگی",
          requiresAuth: true,
          redesigned: true,
        },
        children: [
          {
            path: "list",
            name: "competency-matrix-list",
            component: competencyMatrixList,
            meta: {
              label: "ماتریس شایستگی",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: ":code/detail",
            name: "competency-matrix-detail",
            component: competencyMatrixDetail,
            meta: {
              label: "درج داده‌های تکمیلی ماتریس",
              requiresAuth: true,
              redesigned: true,
              hasBottomNavigation: false,
            },
          },
        ],
      },
      {
        path: "term-dashboard",
        name: "term_dashboard",
        redirect: "/report/term-dashboard/list",
        meta: {
          label: "داشبورد دوره",
          requiresAuth: true,
          redesigned: true,
          hasMaxWidth: false,
        },
        children: [
          {
            path: "list",
            name: "term-dashboard-list",
            component: termDashboard,
            meta: {
              label: "داشبورد دوره",
              requiresAuth: true,
              redesigned: true,
              hasMaxWidth: false,
            },
          },
          {
            path: ":code/detail",
            name: "term-dashboard-detail",
            component: termDashboardDetail,
            meta: {
              label: "گزارش دوره",
              requiresAuth: true,
              redesigned: true,
              hasMaxWidth: false,
            },
          },
        ],
      },
      {
        path: "my-parvandeh-reports",
        name: "my-parvandeh-reports",
        redirect: "/report/my-parvandeh-reports/list",
        meta: {
          label: "گزارش‌های من",
          requiresAuth: true,
          redesigned: true,
          hasMaxWidth: false,
        },
        children: [
          {
            path: "list",
            name: "my_report",
            component: MyReports,
            meta: {
              label: "گزارش‌های من",
              requiresAuth: true,
              redesigned: true,
              hasMaxWidth: false,
            },
          },
        ],
      },
      {
        path: "report-access",
        name: "report_access",
        component: routerParent,
        redirect: "/report/report-access/list",
        meta: {
          label: "دسترسی گزارش‌های بارگذاری شده",
          requiresAuth: true,
          redesigned: true,
        },
        children: [
          {
            path: "list",
            name: "report-access-list",
            component: reportAccessList,
            meta: {
              label: "دسترسی گزارش‌های بارگذاری شده",
              requiresAuth: true,
              redesigned: true,
            },
          },
        ],
      },
    ],
  },
];
